
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#A4A8C0","d":"M16.38 11.567V8.91a.253.253 0 00-.07-.175l-4.567-4.66a.246.246 0 00-.178-.076H5.656C4.306 4 3.99 5.28 4 5.92v11.67c0 2.14 1.565 2.49 2.348 2.397h7.83c1.865 0 2.245-1.5 2.203-2.249v-3.759"}}),_c('path',{attrs:{"stroke":"#A4A8C0","d":"M11.67 6.134V4.627a.25.25 0 01.428-.175l3.864 3.932a.25.25 0 01-.178.425h-1.606c-2.161 0-2.573-1.783-2.509-2.675zm-5.017 11.62c.26-.426.898-1.224 1.458-1.165a.759.759 0 01.17.037c.141.052.365.209.543.57.153.246.54.595.9.12.033-.045.059-.097.085-.147.117-.225.38-.564.735-.564.171-.021.611.046.997.493.134.137.47.315.74-.066"}}),_c('rect',{attrs:{"width":"3.296","height":".128","x":"6.48","y":"10","fill":"#A4A8C0","stroke":"#A4A8C0","rx":".064"}}),_c('rect',{attrs:{"width":"7.168","height":".128","x":"6.48","y":"11.504","fill":"#A4A8C0","stroke":"#A4A8C0","rx":".064"}}),_c('rect',{attrs:{"width":"1.712","height":"10.053","stroke":"#A4A8C0","rx":".856","transform":"matrix(.7014 .71278 -.69816 .71594 18.8 9.065)"}})])
          )
        }
      }
    